import React, { ChangeEvent, useEffect, useMemo, useState } from "react";
import { useAuth } from "../../../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { INotificationSummary, IQuerySelectData } from "../../../../../component/solution/Interfaces";
import { ArrowDown, ArrowUp, Info } from "lucide-react";


export const WholeSaleMovementOutDashbaord: React.FC = () => {

   const { fetchData } = useAuth();
   const navigate = useNavigate(); 

   const queryUrlSelect: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data"}`;
   const [displayDashboard, setDisplayDashboard] = useState<boolean>(false);
   const [notificationSummary, setNotificationSummary] = useState<INotificationSummary[]>([]);

   const defaultQueryState: IQuerySelectData = {
      appCode: "ares",
      selectCode: "notification-summary",
      where: "category IN ('PickList', 'SalesOrder')", 
      orderBy: "",
    };

    const [queryStateTest, setQueryStateTest] = useState<IQuerySelectData>(defaultQueryState);

    useEffect(() => {
        fetchSummary();
    }, [])

    const fetchSummary = () => {
        fetchData(queryUrlSelect, {method:"POST", body: JSON.stringify(queryStateTest)}, processDataDashboard );
    }

    const processDataDashboard = (result: any) => {

      const data: INotificationSummary[] = [];

      for (const key in result.data) {
         const item = result.data[key];
         data.push({ ...item.data});
      } 

      setNotificationSummary(data);
    }

    const thStyle = { backgroundColor: '#f8f9fa', border: '1px solid #deebed', fontWeight: 600,  padding: '12px 8px', fontSize: '0.75rem'};
    const cellStyle: React.CSSProperties = { border: '1px solid #deebed', whiteSpace: 'nowrap', padding: '5px 8px', fontSize: '0.75rem', verticalAlign: 'middle' };

    const salesOrderData = useMemo(() => notificationSummary.filter((d) => d.category === "SalesOrder"), [notificationSummary]);
    const pickListData = useMemo(() => notificationSummary.filter((d) => d.category === "PickList"), [notificationSummary]);


   const TableComponent = (items: INotificationSummary[]) => (
    <div className="notification-summary-container">
      <div className="inner-container">
        <table className="notification-summary-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Description</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan={3} style={{ textAlign: "center", color: "#888" }}>
                  No Data Available For Today
                </td>
              </tr>
            ) : (
              items.map((item, i) => (
                <tr key={i}>
                  <td>{item.category}</td>
                  <td title={item.description}>{item.description}</td>
                  <td style={{ position: "relative" }}>
                    {item.total}
                    <span
                      title="More info"
                      style={{ position: "absolute", top: 4, right: 4, color: "#888", cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        navigate("/m24l/notifications-new", {
                          state: {
                            category: item.category,
                            description: item.description,
                            last_encountered: item.last_encountered,
                          },
                        });
                      }}
                    >
                      <Info size={14} />
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
     <div>
      <div className="notification-summary-layout">
        <button
          className="btn btn-light notification-summary-btn"
          title={displayDashboard ? "Close Display Dashboard" : "Open Display Dashboard"}
          onClick={() => setDisplayDashboard(!displayDashboard)}
        >
          {displayDashboard ? <ArrowUp size={18} /> : <ArrowDown size={18} />}
        </button>
      </div>

      {displayDashboard && (
        <div className="notification-summary-outer-container">
          <div className="outer-inner-container">
            {TableComponent(salesOrderData)}
            {TableComponent(pickListData)}
          </div>
        </div>
      )}
    </div>
  )
}
